module.exports = __webpack_public_path__ + "img/LI.9848f9ac.png";